import { handleActions } from "redux-actions";
import {
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH,
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_COMPLETED,
    // BUYER_DASHBOARD_FETCH,
    // BUYER_DASHBOARD_FETCH_COMPLETED,
    BUYER_DASHBOARD_RECENT_ORDERS_FETCH,
    BUYER_DASHBOARD_RECENT_ORDERS_FETCH_COMPLETED,
    // BUYER_DASHBOARD_RECENT_ORDERS_FILTER,
    // BUYER_DASHBOARD_RECENT_ORDERS_FILTER_COMPLETED,
    // BUYER_DASHBOARD_RECENT_ORDERS_SEARCH,
    // BUYER_DASHBOARD_RECENT_ORDERS_SEARCH_COMPLETED,
    BUYER_SETUP_GUIDE,
    BUYER_DASHBOARD_RETAIL_INTEGRATIONS_PANEL_SET,
} from "constants/action-types";
import { List } from "immutable";
import { ISetupGuideTaskResponse } from "components/buyer-dashboard";

interface IState {
    connectedBrands: string[];
    error?: boolean;
    isFetchingBrands: boolean;
    isFetchingOrders: boolean;
    isFetchingSetupGuideTasks: boolean;
    setupGuideTasks: ISetupGuideTaskResponse[];
    hasSetupGuideErrored: boolean;
    hasCompletedFetchingSetupGuide: boolean;
    meta?: any;
    recentOrders: List<any>;
    showRetailIntegrationsPanel: boolean;
}

const initialState: IState = {
    connectedBrands: [],
    error: undefined,
    isFetchingBrands: false,
    isFetchingOrders: false,
    isFetchingSetupGuideTasks: false,
    setupGuideTasks: [],
    hasSetupGuideErrored: false,
    hasCompletedFetchingSetupGuide: false,
    meta: undefined,
    recentOrders: List(),
    showRetailIntegrationsPanel: true,
};

export const buyerDashboard = handleActions(
    {
        // [BUYER_DASHBOARD_FETCH]: (state: IState, { payload, error }: any): IState => {
        //     return {
        //         ...state,
        //     };
        // },
        // [BUYER_DASHBOARD_FETCH_COMPLETED]: (state: IState, { payload, error }: any): IState => {
        //     return {
        //         ...state,
        //     };
        // },
        [BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH]: (state: IState): IState => {
            return {
                ...state,
                isFetchingBrands: true,
            };
        },
        [BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetchingBrands: false,
                };
            }
            return {
                ...state,
                isFetchingBrands: false,
                connectedBrands: payload,
            };
        },
        [BUYER_DASHBOARD_RECENT_ORDERS_FETCH]: (state: IState): IState => {
            return {
                ...state,
                isFetchingOrders: true,
            };
        },
        [BUYER_DASHBOARD_RECENT_ORDERS_FETCH_COMPLETED]: (state: IState, { payload, meta, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetchingOrders: false,
                    // orderError: error
                };
            }
            return {
                ...state,
                meta,
                recentOrders: payload,
                isFetchingOrders: false,
            };
        },
        [BUYER_SETUP_GUIDE.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetchingSetupGuideTasks: true,
                setupGuideTasks: [],
            };
        },
        [BUYER_SETUP_GUIDE.FETCH.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                isFetchingSetupGuideTasks: false,
                setupGuideTasks: payload,
                hasSetupGuideErrored: false,
                hasCompletedFetchingSetupGuide: true,
            };
        },
        [BUYER_SETUP_GUIDE.FETCH.ERROR]: (state: IState): IState => {
            return {
                ...state,
                hasSetupGuideErrored: true,
                isFetchingSetupGuideTasks: false,
                setupGuideTasks: [],
                hasCompletedFetchingSetupGuide: true,
            };
        },
        [BUYER_DASHBOARD_RETAIL_INTEGRATIONS_PANEL_SET]: (state: IState, { payload }: { payload: boolean }): IState => {
            if (state.showRetailIntegrationsPanel === payload) {
                return state;
            }

            return {
                ...state,
                showRetailIntegrationsPanel: payload,
            };
        },
    },
    initialState
);
